var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import * as React from 'react';
import Button from '@doordash/component-button';
import { StackChildren, Text, InlineChildren } from '@doordash/design-language';
import * as yup from 'yup';
import { getArrayFromMemberList } from './add_members_modal';
import { TextField } from '@doordash/component-fields';
import { Formik, Form } from 'formik';
import styled from 'styled-components';
import { AddMembersModalTestId } from '../testId';
import MembersStrings from './MembersStrings';
import TeamAccountMemberLimitReachedBanner from '../Common/TeamAccountMemberLimitReached/TeamAccountMemberLimitReachedBanner';
var strings = MembersStrings.addMembersForm;
var ButtonGroupContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 180px;\n"], ["\n  width: 180px;\n"])));
export var membersRequestSchema = yup.object().shape({
    members: yup
        .array()
        .transform(function (value, originalValue) {
        if (this.isType(value) && value !== null) {
            return value;
        }
        return getArrayFromMemberList(originalValue);
    })
        .of(yup
        .string()
        .required('Please provide a valid email. ')
        .email(function (_a) {
        var value = _a.value;
        return value + " is not a valid email. ";
    }))
        .required('Members are required.'),
});
var AddMembersForm = function (_a) {
    var setTitle = _a.setTitle, handleFormSubmit = _a.handleFormSubmit, formResponse = _a.formResponse, onClose = _a.onClose, maxMembersLimit = _a.maxMembersLimit, totalMembersCount = _a.totalMembersCount, showLimitationErrorBanner = _a.showLimitationErrorBanner, teamAccountId = _a.teamAccountId;
    var initialFormValues = {
        members: '',
    };
    React.useEffect(function () {
        if (setTitle) {
            setTitle(strings.modalTitle());
        }
    }, [setTitle]);
    return (React.createElement(Formik, { initialValues: initialFormValues, validationSchema: membersRequestSchema, validateOnChange: false, validateOnBlur: false, onSubmit: handleFormSubmit }, function (_a) {
        var _b, _c;
        var values = _a.values, errors = _a.errors, handleChange = _a.handleChange, isSubmitting = _a.isSubmitting, handleSubmit = _a.handleSubmit;
        return (React.createElement(Form, { noValidate: true },
            React.createElement(StackChildren, { size: StackChildren.Sizes.Large },
                React.createElement(Text, { styles: Text.Styles.Label2 },
                    strings.modalDescription(),
                    ' ',
                    maxMembersLimit &&
                        strings.modalDescriptionPlusLimitation(maxMembersLimit - totalMembersCount, maxMembersLimit)),
                showLimitationErrorBanner && (React.createElement(TeamAccountMemberLimitReachedBanner, { remainingTeamMemberSlots: maxMembersLimit - totalMembersCount, teamAccountId: teamAccountId })),
                React.createElement(TextField, { "data-testid": "add-members-textarea", label: "Members", isLabelHidden: true, placeholder: "person1@company.com, person2@company.com, person3@company.com", isRequired: true, autoComplete: "off", error: errors.members, onChange: handleChange('members'), value: values.members, isMultiline: 5 }),
                React.createElement(InlineChildren, { alignItems: InlineChildren.Alignment.Center, justifyContent: InlineChildren.Justification.FlexEnd },
                    React.createElement(ButtonGroupContainer, null,
                        React.createElement(InlineChildren, { alignItems: InlineChildren.Alignment.Center },
                            React.createElement(Button, { type: Button.Types.TertiaryPill, onClick: onClose, "data-testid": AddMembersModalTestId.AddMembersCancelButton }, "Cancel"),
                            React.createElement(Button, { type: Button.Types.PrimaryPill, onClick: handleSubmit, disabled: isSubmitting, state: isSubmitting
                                    ? Button.States.Loading
                                    : Button.States.Default, "data-testid": AddMembersModalTestId.AddMembersSubmitButton }, "Add")))),
                Boolean((_b = formResponse.response) === null || _b === void 0 ? void 0 : _b.errorMessage) ? (React.createElement(Text, { color: Text.Colors.TextError, textAlign: Text.TextAlignments.Center }, (_c = formResponse.response) === null || _c === void 0 ? void 0 : _c.errorMessage)) : null)));
    }));
};
export default AddMembersForm;
var templateObject_1;
